function debounce(method, delay) {
        clearTimeout(method._tId);
        method._tId= setTimeout(function(){
            method();
        }, delay);
    }

const headerElement = document.querySelector('#shopify-section-header');
const handlePageScroll = function (e) {
  console.log('ran');
  if (window.scrollY > headerElement.getBoundingClientRect().height) {
    headerElement.classList.add('scrolled');
  } else {
    headerElement.classList.remove('scrolled');
  }
};

window.addEventListener('scroll', handlePageScroll);